import { useCallback, useState } from 'react';

import { defaultLimit } from 'views/CRM/shared/utils/pagination';

import WhatsappBlockListService from '../services';

export const useListActiveWhatsappBlockList = ({ sortConfig }) => {
  const [whatsappBlockNumbersList, setWhatsappBlockNumbersList] = useState([]);
  const [totalWhatsappBlockNumbers, setTotalWhatsappBlockNumbers] = useState(0);
  const [isLoadingWhatsappBlockNumbers, setIsLoadingWhatsappBlockNumbers] =
    useState(false);

  const getWhatsappBlockNumbers = useCallback(
    (page = 1, params = {}) => {
      setIsLoadingWhatsappBlockNumbers(true);

      const orderType =
        sortConfig?.direction === null ||
        sortConfig?.direction === undefined ||
        sortConfig?.direction === 'ascending' ||
        sortConfig?.direction === 'ascendant'
          ? 'ASC'
          : 'DESC';

      let orderBy = sortConfig?.key;

      WhatsappBlockListService.list(
        { ...params, orderType, orderBy },
        { page, limit: defaultLimit }
      )
        .then((response) => {
          setWhatsappBlockNumbersList(response.data.data);
          setTotalWhatsappBlockNumbers(response.data.quantity);
        })
        .finally(() => setIsLoadingWhatsappBlockNumbers(false));
    },
    [sortConfig]
  );

  return {
    whatsappBlockNumbersList,
    totalWhatsappBlockNumbers,
    isLoadingWhatsappBlockNumbers,
    getWhatsappBlockNumbers
  };
};
